import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/useAuth.js";

export default function LoginPage() {
  const { login, isAuthenticated } = useAuth();
  const location = useLocation();
  const [form, setForm] = useState({ login: "", password: "", rememberMe: false });
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (isAuthenticated) {
    const from = location.state?.from || "/car";
    return <Navigate to={from} replace />;
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(form);
    } catch (err) {
      const payload = err?.payload;
      if (payload?.response === "invalid_app_type") {
        setError("Backend rejected app_type. Update AG_APP_TYPE on the server.");
      } else if (payload?.response === "outdated") {
        setError(`Client is outdated. Minimum supported version: ${payload?.data?.minVersion || "?"}.`);
      } else if (err?.status === 401) {
        setError("Invalid credentials.");
      } else {
        setError(err?.message || "Login failed.");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="card login-card">
        <h1>AHistory</h1>
        <p className="lead">Sign in with your AHistory account.</p>

        <form className="login-form" onSubmit={handleSubmit} autoComplete="on">
          <div>
            <label htmlFor="login">Email / User ID</label>
            <input
              id="login"
              name="login"
              type="text"
              value={form.login}
              onChange={handleChange}
              autoComplete="username"
              required
              style={{ width: "100%" }}
            />
          </div>
          <div>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              autoComplete="current-password"
              required
              style={{ width: "100%" }}
            />
          </div>

          <div className="actions">
            <label>
              <input
                type="checkbox"
                name="rememberMe"
                checked={form.rememberMe}
                onChange={handleChange}
              />
              Remember me
            </label>
            <a href="https://auctiongate.io/forgot-password" target="_blank" rel="noreferrer">
              Forgot password?
            </a>
          </div>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="btn btn-primary" disabled={busy} style={{ marginTop: 6 }}>
            {busy ? <span className="loader" /> : "Log in"}
          </button>
        </form>

        <p className="small muted mt-4 text-center">
          No account?{" "}
          <a href="https://auctiongate.io/register" target="_blank" rel="noreferrer">
            Sign up
          </a>
        </p>
      </div>
    </div>
  );
}
